import React, { useEffect } from 'react';
import { useLogout } from 'react-admin';
import { useUrlParams } from '../shared/hooks/useUrlParams';
import { logout as awsLogout } from '../shared/utils/logout';

type LogoutPageProps = {};

const LogoutPage = (props: LogoutPageProps) => {
  const params = useUrlParams();
  const isAwsLogout = params.get('logoutAws');
  const redirectTo = params.get('redirectTo');

  const logout = useLogout();
  useEffect(() => {
    if (isAwsLogout) {
      awsLogout();
    } else {
      logout(null, redirectTo ? redirectTo : '/login', false);
    }
  }, []);

  return null;
};

export default LogoutPage;
